import { render, staticRenderFns } from "./closing-wired-funds.vue?vue&type=template&id=10089a9a"
import script from "./closing-wired-funds.vue?vue&type=script&lang=js"
export * from "./closing-wired-funds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports